import React, { useContext } from "react";
import CartItems from "../components/cartItems/cartItems";
import './css/cart.css';
import { ShopContext } from "../context/shopContext";

const Cart = () => {
    const { itemsInCart } = useContext(ShopContext);

    const alertBox = () => {
        return itemsInCart() > 1;
    };

    return (
        <div>
           
            {alertBox() && (
                <div className='alert-box'>
                    <p>Please be aware that we do not yet support sending to multiple addresses!</p>
                </div>
            )}

            <CartItems />
        </div>
    );
};

export default Cart;
